export const getAmplitudeClientKey = () => {
  if (typeof window === 'undefined') return undefined;

  const prodWebClient = 'client-QodxfMkQTCUM6mRu3YxZl155AdcYFOzm';
  const stageWebClient = 'client-uos9cO3DnoQgD4CXCi1vjfC4mAqAqWOx';
  const testWebClient = 'client-pIEv6zMtRBZJmSdGqwReldW2NhMMkUfc';

  if (process.env.NODE_ENV === 'development') {
    return testWebClient;
  }
  if (process.env.NODE_ENV === 'production') {
    return window.location.hostname.includes('stg-')
      ? stageWebClient
      : prodWebClient;
  }

  return undefined;
};
